<template lang="pug">
    v-card( class="border-radius elevation-2" )
        v-flex( pa-5 text-xs-center xs12 v-if="busy" )
            v-btn( v-if="show" @click="submitLayoutRefresh" flat ) haz clic aca para recargar...
            template( v-else )
                v-progress-circular( color="primary" indeterminate )
                h4.mt-3 Cargando datos...
        slot( v-else )
</template>

<script>
    export default {
        props: ['busy'],
        data () {
            return {
                pid  : null,
                show : false,
                start: Date.now(),
            }
        },
        methods: {
            end () {
                clearInterval( this.pid )
                this.show = true
            },
            submitLayoutRefresh () {
                this.$router.go()
            },
            tick () {
                if ( this.start + 5000 < Date.now() ) this.end()
            },
        },
        mounted () {
            this.pid = setInterval( this.tick, 500 )
        },
        watch: {
            busy () {
                if ( this.busy ) {
                    this.show = false
                    this.start = Date.now(),
                    clearInterval( this.pid )
                    this.pid = setInterval( this.tick, 500 )
                }
            },
        }
    }
</script>
